/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_No_Hr_DataInputs */

const en_ui_color_by_reason_no_hr_data = /** @type {(inputs: Ui_Color_By_Reason_No_Hr_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No heart rate data`)
};

const de_ui_color_by_reason_no_hr_data = /** @type {(inputs: Ui_Color_By_Reason_No_Hr_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Herzfrequenzdaten`)
};

/**
* | output |
* | --- |
* | "No heart rate data" |
*
* @param {Ui_Color_By_Reason_No_Hr_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_no_hr_data = /** @type {((inputs?: Ui_Color_By_Reason_No_Hr_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_No_Hr_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_no_hr_data(inputs)
	return de_ui_color_by_reason_no_hr_data(inputs)
});